module.exports = __webpack_public_path__ + "static/img/sob.0766d59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/emotions/emoji/sob.png
// module id = TkuY
// module chunks = 0